import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';
import { LoadingSpinner } from './components/loadingSpinner/loadingspinner';
import { NetworkStatus } from './components/networkStatus/NetworkStatus';
import AllRoutes from './routes/AllRoutes';
import { FloatingRecorderBar } from './features/recordingFeature/FloatingRecorderBar';

const App = () => {
    return (
        <>
            <ToastContainer />
            <div className="App">
                <BrowserRouter>
                    <NetworkStatus />
                    <AllRoutes />
                    {/* FloatingRecorderBar lives inside BrowserRouter so it can navigate */}
                    <FloatingRecorderBar />
                </BrowserRouter>
            </div>
            <div className="divSpinner" style={{ display: 'none' }}>
                <LoadingSpinner />
            </div>
        </>
    );
};

export default App;
